import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { getFromLocalStorage } from "../../utils/localstorage";
import isTokenExpired from "../../helpers/isTokenExpired";
import { LocalStorageEnum } from "../../utils/localstorage/LocalStorageEnum";
import envconf from "../../envConfig";
import { toast } from "react-toastify";

interface ProtectedInProps {
  children: JSX.Element;
}

const ProtectedIn: React.FC<ProtectedInProps> = ({ children }) => {
  const token = getFromLocalStorage(LocalStorageEnum.TOKEN);
    toast.info("Yo!");
  
  // Skip auth logic in dev mode
  if (envconf?.IS_DEV) return children;

  const isAuthenticated = token && !isTokenExpired(token);

  if (isAuthenticated) {
    toast.info("You're already logged in!");
    return <Navigate to="/acceuil" replace />;
  }

  return children;
};

export default ProtectedIn;
